import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { syncFaqSchema } from '../config/faqSchema.mjs';
import { syncTemplateStructuredData } from '../config/templatePages.mjs';

const PublicStructuredDataManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    syncFaqSchema(pathname);
    syncTemplateStructuredData(pathname);
  }, [pathname]);

  return null;
};

export default PublicStructuredDataManager;
